import { MoreHorizontal } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { cn } from '~/lib/utils';

/**
 * The control every mail client uses for a quoted chain: three dots where the
 * quote begins.
 *
 * One way only. Nobody hides a chain they have just read, and a control that
 * stays behind to offer it is one more thing in a message that is already
 * mostly somebody else's words.
 *
 * `onPrimary` is which surface it sits on — the feed's outbound bubble carries
 * its own colour, and a grey chip on top of it reads as a hole.
 */
export function QuotedTextButton({
  className,
  onPrimary = false,
  onShow,
}: {
  className?: string;
  onPrimary?: boolean;
  onShow: () => void;
}) {
  const { t } = useTranslation();
  const label = t('Show trimmed content');

  return (
    <button
      type="button"
      onClick={onShow}
      title={label}
      aria-label={label}
      className={cn(
        'inline-flex h-4 w-7 shrink-0 cursor-pointer items-center justify-center rounded-sm transition-colors',
        onPrimary
          ? 'bg-white/20 text-primary-foreground hover:bg-white/30'
          : 'bg-muted text-muted-foreground hover:bg-accent hover:text-foreground',
        className,
      )}
    >
      <MoreHorizontal className="size-3" strokeWidth={2.5} />
    </button>
  );
}
